/** 土地流转 */
import { axios } from '@/utils/request'

export function LandTransferAreaWebPage(parameter) {
  return axios({
    url: '/LandTransferArea/web/page',
    method: 'get',
    params: parameter
  })
}
// 新闻中心消息文本
export function LandTransferAreaWebDetail(parameter) {
  return axios({
    url: '/LandTransferArea/web/detail',
    method: 'get',
    params: parameter
  })
}
